import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import nextholiIcon from '../assets/nextholi-icon.png';
import { trackPageView } from '../utils/analytics';

const NextHoliPrivacy = () => {
  useEffect(() => {
    trackPageView('NextHoli Privacy Policy');
  }, []);

  return (
    <div className="privacy-container">
      <header className="privacy-header">
        <div className="app-info">
          <div className="app-icon">
            <img src={nextholiIcon} alt="NextHoli" />
          </div>
          <div className="app-details">
            <h1>NextHoli</h1>
            <p>Privacy Policy</p>
          </div>
        </div>
        <Link to="/" className="back-link">← Back to Home</Link>
      </header>

      <main className="privacy-content">
        <div className="privacy-section">
          <h2>Information We Collect</h2>
          <p>NextHoli respects your privacy. We do not collect any personal information or track your usage behavior. The app is designed with a privacy-first approach.</p>
        </div>

        <div className="privacy-section">
          <h2>Holiday Data</h2>
          <p>All public holiday data is bundled within the app and does not require network access to function. Holiday information is processed entirely on your device.</p>
        </div>

        <div className="privacy-section">
          <h2>iCloud Sync</h2>
          <p>NextHoli uses Apple's iCloud (NSUbiquitousKeyValueStore) to sync your app preferences (such as selected countries and countdown format) across your devices. This data is stored securely in your personal iCloud account and is not accessible to us or any third party.</p>
        </div>

        <div className="privacy-section">
          <h2>Location Data</h2>
          <p>The app may request your location to display local weather information on the home screen. Location data is used solely for this purpose, processed on-device via Apple's WeatherKit, and is never stored, shared, or transmitted to our servers.</p>
        </div>

        <div className="privacy-section">
          <h2>In-App Purchases</h2>
          <p>NextHoli offers optional subscription plans (monthly and yearly) through Apple's StoreKit. All purchase transactions are handled securely by Apple. We do not have access to your payment information.</p>
        </div>

        <div className="privacy-section">
          <h2>Widgets</h2>
          <p>NextHoli provides home screen and lock screen widgets. Widget data (holiday countdown information) is shared between the app and widget extension via App Groups, stored locally on your device only.</p>
        </div>

        <div className="privacy-section">
          <h2>Third-Party Services</h2>
          <p>NextHoli does not use any third-party analytics, advertising networks, or data collection services. The only external service used is Apple's WeatherKit for weather display, which is governed by Apple's own privacy policy.</p>
        </div>

        <div className="privacy-section">
          <h2>Data Storage</h2>
          <p>All user preferences, selected countries, and app settings are stored locally on your device and in your personal iCloud account. We do not operate any servers that store your data.</p>
        </div>

        <div className="privacy-section">
          <h2>Children's Privacy</h2>
          <p>NextHoli does not knowingly collect any information from children. The app is rated 4+ and contains no objectionable content.</p>
        </div>

        <div className="privacy-section">
          <h2>Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at:</p>
          <p><strong>Email:</strong> feedback@peacetech.app</p>
        </div>

        <div className="privacy-section">
          <h2>Updates to This Policy</h2>
          <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
          <p><strong>Last updated:</strong> March 2026</p>
        </div>
      </main>
    </div>
  );
};

export default NextHoliPrivacy;
